import { useQuery } from "@tanstack/react-query"

import { supabase } from "@/lib/supabase"

import type { Tables } from "../../database.types"

export type CarPark = Pick<Tables<"car_parks">, "id" | "name" | "address">

export const useCarParks = () =>
  useQuery({
    queryKey: ["car-parks"],
    queryFn: async (): Promise<CarPark[]> => {
      const { data, error } = await supabase.from("car_parks").select("id, name, address")
      if (error) throw error
      return data ?? []
    },
  })
